import React from 'react';
import routes from 'modules/Layouts/routes';
import SectionpageCard from 'components/SectionPageCard';

const CustomersAndRestaurantsPage: React.FC = () => {
	const route = routes.find((route) => route.name === 'customersAndRestaurants');

	return (
		<div className="sectionPage">
			{route?.subroutes.map((subroute) => (
				<SectionpageCard subroute={subroute} key={`${subroute.path}-card`} />
			))}
		</div>
	);
};

export default CustomersAndRestaurantsPage;
